const boxTokens = ({ colors }) => ({
  colors: {
    branded: colors.white,
  },
});

export default boxTokens;
